/*
 * Purpose: Mission map canvas tools — add block, undo, layout (first-class sub-nav)
 * Last modified: 2026-07-01 | Agent
 * Completeness: 100
 */
import { useMissionWorkspace } from '@/contexts/MissionWorkspaceContext';
import { CanvasToolbar } from '@/components/CanvasToolbar';
import { useWorkflowStore } from '@/stores/workflowStore';

export function MissionMapToolNav({
  className,
  inverted = false,
}: {
  className?: string;
  inverted?: boolean;
}) {
  const { mapTools } = useMissionWorkspace();
  const currentWorkflow = useWorkflowStore((s) => s.currentWorkflow);

  if (!mapTools || !currentWorkflow) return null;

  return (
    <CanvasToolbar
      variant="strip"
      inverted={inverted}
      className={className}
      zoom={mapTools.zoom}
      onZoomIn={mapTools.onZoomIn}
      onZoomOut={mapTools.onZoomOut}
      workflow={currentWorkflow}
      onAddBlock={mapTools.onAddBlock}
      flowOrientation={mapTools.flowOrientation}
      effectiveFlowOrientation={mapTools.effectiveFlowOrientation}
      onFlowOrientationChange={mapTools.onFlowOrientationChange}
    />
  );
}
